import { normalize } from "./util.js";
import { state } from "./state.js";

function scoreItem(item, q) {
  const name = normalize(item.name);
  const slug = normalize(item.slug);
  if (name === q) return 100;
  if (name.startsWith(q)) return 90;
  if (slug.startsWith(q)) return 85;
  if (name.includes(` ${q}`)) return 70;
  if (name.includes(q)) return 60;
  if (slug.includes(q)) return 50;
  const group = normalize(item.group);
  if (group.includes(q)) return 30;
  const catalogue = normalize(item.catalogue);
  if (catalogue.includes(q)) return 25;
  return 0;
}

function preferItem(a, b) {
  const aRecipes = a.recipeCount || 0;
  const bRecipes = b.recipeCount || 0;
  if (aRecipes !== bRecipes) return aRecipes > bRecipes ? a : b;
  if (a.slug.length !== b.slug.length) return a.slug.length < b.slug.length ? a : b;
  return a.slug < b.slug ? a : b;
}

/** Search with display-name dedupe (NMS late-fix applied from day one). */
export function searchItems(query) {
  const q = normalize(query).trim();
  if (!q) return [];
  const scored = [];
  for (const item of state.items) {
    const score = scoreItem(item, q);
    if (score > 0) scored.push({ item, score });
  }
  scored.sort((a, b) => b.score - a.score || a.item.name.localeCompare(b.item.name));

  const byName = new Map();
  for (const row of scored) {
    const key = normalize(row.item.name);
    const prev = byName.get(key);
    if (!prev) {
      byName.set(key, row);
      continue;
    }
    const preferred = preferItem(prev.item, row.item);
    byName.set(key, {
      item: preferred,
      score: Math.max(prev.score, row.score),
    });
  }

  return [...byName.values()]
    .sort((a, b) => b.score - a.score || a.item.name.localeCompare(b.item.name))
    .slice(0, 40)
    .map((x) => x.item);
}
